export enum ShutdownTimeoutType {
  start,
  end,
}

export interface ShutdownTimeout {
  type: ShutdownTimeoutType;
  timeInMs: number;
}
